import { useNuxtApp } from '#imports'
import type { apm } from '@elastic/apm-rum'

export const useApm = () => {
    const { vueApp } = useNuxtApp()
    return (vueApp.config.globalProperties.$apm ?? { captureError() {} }) as typeof apm
}
